import React from 'react';
import $ from "jquery"

const ReactMarkdown = require('react-markdown')

class Banner extends React.Component{

    componentDidMount(){
        if($(".banner-text").text().length > 400 && $(window).width() < 1000){
            $(".banner-text p").css("font-size","30px");
            $(".banner-text p").css("line-height","28px");
            $(".banner-text blockquote p").css("font-size","16px");
            $(".banner-text blockquote p").css("line-height","18px");
        }
    }

    render(){
        return (
            <div className="row banner" style={{"backgroundImage":"url("+this.props.fields.image.fields.file.url+")"}}>
                <div className="banner-overlay"></div>
                <div className={"col-"+ ($(window).width()<1000?"lg-":"") +"6 offset-"+ ($(window).width()<1000?"lg-":"") +"3 banner-text"}>
                    <ReactMarkdown escapeHtml={false} source={this.props.fields.text}/>
                </div>
            </div>
        )
    }
}

export default Banner;
